import { RightToLeftLanguages } from './i18n/RightToLeftLanguages';
import { SupportedLocale } from '../types';

export function isRightToLeftLanguage(locale: SupportedLocale): boolean {
  return (RightToLeftLanguages as string[]).includes(locale);
}
